import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ArrowIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 70 10" {...props}>
      <Box as="path" fill="new.green.500" d="M70 5 62.5.67v8.66L70 5ZM0 5.75h63.25v-1.5H0v1.5Z" />
    </Icon>
  );
}
